import { render, staticRenderFns } from "./RegistrarNuevaLicenciaDialogComponent.vue?vue&type=template&id=742c5564&scoped=true"
import script from "./RegistrarNuevaLicenciaDialogComponent.vue?vue&type=script&lang=js"
export * from "./RegistrarNuevaLicenciaDialogComponent.vue?vue&type=script&lang=js"
import style0 from "./RegistrarNuevaLicenciaDialogComponent.vue?vue&type=style&index=0&id=742c5564&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742c5564",
  null
  
)

export default component.exports